export default "__VITE_ASSET__B5CsfwM7__"